export function getGtmName(name: string): string {
    switch (true) {
        // customer fields
        case name.includes('customer.name.title'):
            return 'customerTitle';
        case name.includes('customer.name.forename'):
            return 'firstname';
        case name.includes('customer.name.surname'):
            return 'lastname';
        case name.includes('customer.maritalStatus'):
            return 'maritalStatus';
        case name.includes('customer.name.dependants'):
            return 'numberOfDependants';
        case name.includes('customer.name.residentialStatus'):
            return 'homeOwnerStatus';
        case name.includes('customer.telephone'):
            return 'mob';

        // address fields
        case name.includes('customer.address.currentAddress.flatNumber'):
        case name.includes('customer.address.previousAddresses.0.flatNumber'):
        case name.includes('customer.address.previousAddresses.1.flatNumber'):
        case name.includes('loan.otherDeliveryAddress.flatNumber'):
            return 'flat';
        case name.includes('customer.address.currentAddress.houseName'):
        case name.includes('customer.address.previousAddresses.0.houseName'):
        case name.includes('customer.address.previousAddresses.1.houseName'):
        case name.includes('loan.otherDeliveryAddress.houseName'):
            return 'houseName';
        case name.includes('customer.address.currentAddress.houseNumber'):
        case name.includes('customer.address.previousAddresses.0.houseNumber'):
        case name.includes('customer.address.previousAddresses.1.houseNumber'):
        case name.includes('loan.otherDeliveryAddress.houseNumber'):
            return 'houseNumber';
        case name.includes('customer.address.currentAddress.street'):
        case name.includes('customer.address.previousAddresses.0.street'):
        case name.includes('customer.address.previousAddresses.1.street'):
        case name.includes('loan.otherDeliveryAddress.street'):
            return 'street';
        case name.includes('customer.address.currentAddress.town'):
        case name.includes('customer.address.currentAddress.city'):
        case name.includes('customer.address.previousAddresses.0.town'):
        case name.includes('customer.address.previousAddresses.0.city'):
        case name.includes('customer.address.previousAddresses.1.town'):
        case name.includes('customer.address.previousAddresses.1.city'):
        case name.includes('loan.otherDeliveryAddress.town'):
        case name.includes('loan.otherDeliveryAddress.city'):
            return 'town';
        case name.includes('customer.address.currentAddress.county'):
        case name.includes('customer.address.previousAddresses.0.county'):
        case name.includes('customer.address.previousAddresses.1.county'):
        case name.includes('loan.otherDeliveryAddress.county'):
            return 'county';
        case name.includes('customer.address.currentAddress.postCode'):
        case name.includes('customer.address.previousAddresses.0.postCode'):
        case name.includes('customer.address.previousAddresses.1.postCode'):
        case name.includes('loan.otherDeliveryAddress.postCode'):
            return 'postcode';
        case name.includes('customer.address.currentAddress.years'):
        case name.includes('customer.address.previousAddresses.0.years'):
        case name.includes('customer.address.previousAddresses.1.years'):
            return 'manualTimeAtYears';
        case name.includes('customer.address.currentAddress.months'):
        case name.includes('customer.address.previousAddresses.0.months'):
        case name.includes('customer.address.previousAddresses.1.months'):
            return 'manualTimeAtMonths';

        // employment fields
        case name.includes('customer.employment.status'):
            return 'employmentStatus';
        case name.includes('customer.employment.occupation'):
            return 'occupation';
        case name.includes('customer.employment.employerName'):
            return 'employerName';
        case name.includes('customer.employment.employmentTenure.years'):
            return 'employerTimeAtYears';
        case name.includes('customer.employment.employmentTenure.months'):
            return 'employerTimeAtMonths';

        // bank fields
        case name.includes('customer.banking.accountName'):
            return 'bankName';
        case name.includes('customer.banking.accountNumber'):
            return 'accountNumber';
        case name.includes('customer.banking.sortCode'):
            return 'sortCode1';
        case name.includes('customer.banking.accountHeld.years'):
            return 'bankAccountYears';
        case name.includes('customer.banking.accountHeld.months'):
            return 'bankAccountMonths';

        default: {
            let splitedName = name.split('.');

            return splitedName.pop() ?? '';
        }
    }
}
